import { z } from 'zod';

// src/widget/primitives/common.ts
var PRIMITIVE_STRING_MAX = 4e3;
var PRIMITIVE_LABEL_MAX = 200;
var PRIMITIVE_LIST_MAX_ITEMS = 100;
var PRIMITIVE_TABLE_MAX_ROWS = 200;
var PRIMITIVE_TABLE_MAX_COLUMNS = 20;
var PRIMITIVE_FORM_MAX_FIELDS = 30;
var PRIMITIVE_MARKDOWN_MAX = 2e4;
var LabelSchema = /* @__PURE__ */ z.string().min(1).max(PRIMITIVE_LABEL_MAX);
var BodyTextSchema = /* @__PURE__ */ z.string().min(1).max(PRIMITIVE_STRING_MAX);
var ActionToolCategorySchema = /* @__PURE__ */ z.enum(["read", "write", "destructive"]);
var ActionSchema = /* @__PURE__ */ z.object({
  /** Stable identifier the orchestrator binds the tool call to. */
  id: z.string().min(1).max(120),
  /** Visible label shown on the action button. */
  label: LabelSchema,
  /** Tool category hint for visual emphasis. */
  tool: ActionToolCategorySchema.optional()
});
var PRIMITIVE_TYPES = [
  "list",
  "table",
  "card",
  "markdown",
  "button",
  "detail",
  "form",
  "status",
  "emptyState",
  "confirmCard",
  "navigate",
  "component",
  "iframe",
  "actionPlan",
  "actionInProgress",
  "actionResult",
  "chart",
  "embed",
  "metric",
  "funnel",
  // SYN-206 — the multi-step input wizard (distinct from the funnel CHART).
  "flow",
  // AVM Phase D — the anonymous → authenticated sign-in conversion handoff.
  "signInCard",
  // W-31 — the assistant-led onboarding checklist (walkthrough-backed steps,
  // persistent per-end-user completion). Labs-gated behind `onboarding-checklist`.
  "onboardingChecklist"
];
var ACCENT_AWARE_PRIMITIVE_TYPES = [
  "list",
  "table",
  "card",
  "markdown",
  "button",
  "form",
  "confirmCard",
  "navigate",
  "actionPlan",
  "actionInProgress",
  // SYN-315 — `chart` and `funnel` paint their data marks/bars from the
  // categorical `--syncanix-chart-*` palette, NOT `--syncanix-primary`, so a
  // per-component Accent control can't recolour them (it would be a dead control).
  // Their colours are owned by the design-level Brand chart palette. Excluded.
  "flow",
  // AVM Phase D — the SignInCard's primary CTA paints from `--syncanix-primary`.
  "signInCard",
  // W-31 — the onboarding checklist's "Show me how" CTA + completed-tick paint
  // from `--syncanix-primary`.
  "onboardingChecklist"
];
var PrimitiveTypeSchema = /* @__PURE__ */ z.enum(PRIMITIVE_TYPES);

export { ACCENT_AWARE_PRIMITIVE_TYPES, ActionSchema, ActionToolCategorySchema, BodyTextSchema, LabelSchema, PRIMITIVE_FORM_MAX_FIELDS, PRIMITIVE_LABEL_MAX, PRIMITIVE_LIST_MAX_ITEMS, PRIMITIVE_MARKDOWN_MAX, PRIMITIVE_STRING_MAX, PRIMITIVE_TABLE_MAX_COLUMNS, PRIMITIVE_TABLE_MAX_ROWS, PRIMITIVE_TYPES, PrimitiveTypeSchema };
//# sourceMappingURL=chunk-DEPQ2OSO.js.map
//# sourceMappingURL=chunk-DEPQ2OSO.js.map